import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phone", "mobile", "cpf", "cnpj", "cep", "document", "documentType"]

  connect() {
    if (typeof window.VMasker !== 'undefined') {
      this.applyMasks()
    } else {
      console.error('VMasker not available')
    }
  }

  applyMasks() {
    if (typeof window.VMasker === 'undefined') {
      console.error("VMasker not available")
      return
    }

    // Máscara para telefone
    const phoneElements = this.hasPhoneTarget ? this.phoneTargets : (this.element.dataset.maskType === 'phone' ? [this.element] : [])
    phoneElements.forEach((element) => {
      if (!element) return
      window.VMasker(element).maskPattern("(99) 99999-9999")
    })

    // Máscara para celular
    const mobileElements = this.hasMobileTarget ? this.mobileTargets : (this.element.dataset.maskType === 'mobile' ? [this.element] : [])
    mobileElements.forEach((element) => {
      if (!element) return
      window.VMasker(element).maskPattern("(99) 99999-9999")
    })

    // Máscara para CEP
    if (this.hasCepTarget) {
      this.cepTargets.forEach((element) => {
        if (!element) return
        window.VMasker(element).maskPattern("99999-999")
      })
    }

    // Máscara para CPF
    if (this.hasCpfTarget) {
      this.cpfTargets.forEach((element) => {
        if (!element) return
        this._applyMask(element, "999.999.999-99")
      })
    }

    // Máscara para CNPJ
    if (this.hasCnpjTarget) {
      this.cnpjTargets.forEach((element) => {
        if (!element) return
        this._applyMask(element, "99.999.999/9999-99")
      })
    }

    // Máscara para Documentos (CPF/CNPJ)
    this.initialDocumentMask()
    
    // Listener para mudança de tipo de documento
    if (this.hasDocumentTypeTarget) {
      this.documentTypeTargets.forEach((typeElement) => {
        typeElement.addEventListener('change', () => this.applyDocumentMask())
      })
    }
  }

  initialDocumentMask() {
    if (!this.hasDocumentTarget) return

    this.documentTargets.forEach((element) => {
      if (!element) return
      
      // Se tivermos um seletor de tipo, usamos ele para definir a máscara inicial
      if (this.hasDocumentTypeTarget) {
        this._updateDocumentMask(element, this.documentTypeTarget.value)
      } else {
        // Fallback: máscara dinâmica baseada no tamanho
        this._applyDynamicDocumentMask(element)
      }
    })
  }

  applyDocumentMask() {
    if (!this.hasDocumentTarget || !this.hasDocumentTypeTarget) return

    const type = this.documentTypeTarget.value
    this.documentTargets.forEach((element) => {
      this._updateDocumentMask(element, type)
    })
  }

  _updateDocumentMask(element, type) {
    window.VMasker(element).unbindElementToMask()
    const pattern = type === 'cnpj' ? "99.999.999/9999-99" : "999.999.999-99"
    const placeholder = type === 'cnpj' ? "00.000.000/0000-00" : "000.000.000-00"
    
    element.placeholder = placeholder
    window.VMasker(element).maskPattern(pattern)
  }

  _applyDynamicDocumentMask(element) {
    element.addEventListener('input', (e) => {
      const value = e.target.value.replace(/\D/g, '')
      window.VMasker(element).unbindElementToMask()
      
      if (value.length <= 11) {
        window.VMasker(element).maskPattern("999.999.999-99")
      } else {
        window.VMasker(element).maskPattern("99.999.999/9999-99")
      }
    })
  }

  getCleanValue(element) {
    if (!element) return ''
    return element.value.replace(/\D/g, '')
  }

  // Aplica a máscara e formata o valor já presente no campo (ex.: dados pré-preenchidos no load).
  _applyMask(element, pattern) {
    window.VMasker(element).maskPattern(pattern)
    if (element.value && window.VMasker && typeof window.VMasker.toPattern === 'function') {
      element.value = window.VMasker.toPattern(element.value, pattern)
    }
  }
} 